module.exports = __webpack_public_path__ + "static/cmvretinitis-79cc2d4f2832e6207b687b9f5e5df481.jpg";